import React from 'react';
import ClockNineInfo from '@smart-tv/components/icons/clock-nine-info';
import PlaySentSending from '@smart-tv/components/icons/play-sent-sending';
import RecordingIndicator from '@smart-tv/components/icons/recording-indicator';
import CombinedStringsIcons from '@smart-tv/components/program-sheet/components/sheet-string-icons';
import { calculateExpiryContent } from '@smart-tv/components/program-sheet/components/sheet-description-info-expiry';
import { renderAirtime } from '@smart-tv/components/program-sheet/components/sheet-description-info-airtime';
import isWithinInterval from '@smart-tv/utils/date/is-within-interval';
import { ContentInfoAssetResponse } from '@smart-tv/utils/kmm/getContentInfoForAsset';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

interface Props {
  contentInfoAsset: ContentInfoAssetResponse;
}

const CombinedStringsIconWrapper = ({ contentInfoAsset }: Props) => {
  const { infoBlock, npvrInfo, readableAirTimeOrRecordingTime, expireTime } = contentInfoAsset;

  const isRecording = Boolean(npvrInfo?.customerRecording || npvrInfo?.isSeriesRecording);

  const start = infoBlock?.startTime ? new Date(infoBlock.startTime * 1000) : undefined;
  const end = start ? new Date(start.getTime() + (infoBlock?.duration ?? 0) * 1000) : undefined;
  const isLive = !!start && !!end && isWithinInterval(Date.now(), { start, end });

  const airTime =
    readableAirTimeOrRecordingTime ?? (start ? renderAirtime(start, end) ?? undefined : undefined);

  const msUntilExpiry = expireTime ? expireTime * 1000 - Date.now() : 0;
  const showExpiry = !isLive && msUntilExpiry > 0 && msUntilExpiry <= THIRTY_DAYS_MS;

  return (
    <CombinedStringsIcons
      IconComponent1={airTime ? (isRecording ? RecordingIndicator : PlaySentSending) : undefined}
      part2={airTime}
      IconComponent2={showExpiry ? ClockNineInfo : undefined}
      part3={showExpiry && expireTime ? calculateExpiryContent(expireTime * 1000, true) : undefined}
      isPlayerProductSheet={true}
    />
  );
};

export default CombinedStringsIconWrapper;
